import { gql } from '@apollo/client';

export const GENERATE_BAG_SHIPMENT_SNAPSHOT_DOWNLOAD_REPORT = gql`
    mutation GenerateBagShipmentSnapshotDownloadReport(
        $bagNumber: String!
        $nodeId: String!
        $inBagStatus: BagInBagStatus
        $orderStatuses: [String!]
        $trackingNumber: String
        $timezone: String
    ) {
        generateBagShipmentSnapshotDownloadReport(
            bagNumber: $bagNumber
            nodeId: $nodeId
            inBagStatus: $inBagStatus
            orderStatuses: $orderStatuses
            trackingNumber: $trackingNumber
            timezone: $timezone
        )
    }
`;

export interface GenerateBagShipmentSnapshotDownloadReportVariables {
    bagNumber: string;
    nodeId: string;
    inBagStatus?: 'IN_BAG' | 'OUT_OF_BAG' | null;
    orderStatuses?: string[] | null;
    trackingNumber?: string | null;
    timezone?: string | null;
}

export interface GenerateBagShipmentSnapshotDownloadReportResponse {
    generateBagShipmentSnapshotDownloadReport: string;
}
